export const environment = {
  production: false,
  apiBaseUrl: 'https://kadree-bff-dev-27997527181.us-central1.run.app',
  //apiBaseUrl: 'https://dev.wematch.team',
  googleAuthUrl: 'https://kadree-bff-dev-27997527181.us-central1.run.app/bff/google-login',
  perimeterDevKey: 'EuP2Qv1HBjw7ZF3WNJpoTdKcIlnyYiR9',
  useMocks: false,
};
